import { motion } from "framer-motion";
import { MaskLines, Overline } from "./Reveal";
import { TEAM } from "./data";
import { LogoMark } from "./Logo";

export const Team = () => (
  <section id="team" data-testid="team-section" className="relative py-24 sm:py-36">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
      <Overline>Il team</Overline>
      <h2 className="mt-6 font-display text-5xl sm:text-7xl leading-[0.95] text-ivory">
        <MaskLines lines={["Mani esperte,", <em key="t" className="text-gold-grad">sguardo attento.</em>]} />
      </h2>
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
        {TEAM.map((m, i) => (
          <motion.article
            key={i}
            data-testid={`team-card-${i}`}
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className={`group ${i % 2 === 1 ? "lg:mt-20" : ""}`}
          >
            <div className="relative aspect-[3/4] overflow-hidden rounded-[24px] border border-white/10">
              {m.img ? (
                <img src={m.img} alt={m.name} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale group-hover:grayscale-0 transition-[filter,transform] duration-1000 group-hover:scale-105" />
              ) : (
                <div className="absolute inset-0 grid place-items-center bg-[#0d0d0f]">
                  <LogoMark className="h-20 opacity-40 transition-opacity duration-700 group-hover:opacity-80" />
                  <span className="absolute bottom-6 font-mono text-[11px] uppercase tracking-[0.25em] text-ivory/60">[Foto in arrivo]</span>
                </div>
              )}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <span className="absolute top-5 left-5 font-mono text-[11px] text-gold tracking-[0.2em]">0{i + 1}</span>
            </div>
            <h3 className="mt-5 font-display text-3xl text-ivory">{m.name}</h3>
            <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">{m.role}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
